import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import AboutPage from '../views/AboutPage.vue'
import SolutionPage from '../views/SolutionPage.vue'
import MainServicePage from '../views/MainServicePage.vue'
import ServicePage from '../views/ServicePage.vue'
import ContactPage from '../views/ContactPage.vue'

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
    meta: { title: 'Home | MINE ITS' }
  },
  {
    path: '/about',
    name: 'AboutPage',
    component: AboutPage,
    meta: { title: 'About | MINE ITS' }
  },
  {
    path: '/solutions/:slug',
    name: 'SolutionPage',
    component: SolutionPage,
    meta: { title: 'Solutions | MINE ITS' }
  },
  {
    path: '/services',
    name: 'MainServicePage',
    component: MainServicePage,
    meta: { title: 'Services | MINE ITS' }
  },
  {
    path: '/services/:slug',
    name: 'ServicePage',
    component: ServicePage,
    meta: { title: 'Services | MINE ITS' }
  },
  {
    path: '/contact',
    name: 'ContactPage',
    component: ContactPage,
    meta: { title: 'Contact | MINE ITS' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'MINE ITS';
  next();
});

export default router